import router from "@/router";
import vm from "../../main";
//链接跳转（内部链接/consult/detail/1）（可跳转外链）
export const windowOpen = (option) => {
  let routeNodata = ['/subject-guide/subject-select-major','/subject-guide/add-major','/subject-guide/my-subject-scheme','/fill-guide/school-data','/fill-guide/major-data','/fill-guide/simulation','/fill-guide/admission-plan','/fill-guide/target-school','/fill-guide/score-level','/fill-guide/Batch-line','/fill-guide/points-query','/buy-card','/buy-card/pay']
  // let routeNodata2 = ['/fill-guide/simulation']
  // if (routeNodata2.indexOf(option.path) > -1) {
  //   if (toVueNoData2() == true) {
  //     let newUrl = "/peer" + option.path;
  //     window.open(newUrl, "_blank");
  //     return false;
  //   }
  // }
  // if (routeNodata.indexOf(option.path) > -1) {
  //   if (toVueNoData() == true) {
  //     let url = `/miss-data/${Math.floor((Math.random() * 10) + 1)}`;
  //     vm.$router.push({
  //       path: url,
  //     });
  //     return false;
  //   }
  // }
  let arr = [
    "/subject-guide/subject-select-major",
    "/subject-guide/add-major",
    "/subject-guide/my-subject-scheme",
  ];
  if (arr.indexOf(option.path) > -1) {
    if (vm.cookie.get("token")) {
      let userInfo = vm.cookie.get("userInfo")
        ? JSON.parse(vm.cookie.get("userInfo"))
        : {};
      if (!userInfo.isVIP) {
        vm.$vipModal();
        return;
      }
    }
  }

  let newUrl = "/peer" + option.path;

  window.open(newUrl, "_blank");
};

//页内跳转
export const toUrl = (url, parameters, type = 1) => {
  let routeNodata = ['subjectSelectMajor','addMajor','mySubjectScheme','schoolData','majorData','admissionPlan','targetSchool','scoreLevel','BatchLine','pointsQuery','buyCard','buyCardPay']
  if (routeNodata.indexOf(url) > -1) {
    // if (toVueNoData() == true) {
    //   let url = `/miss-data/${Math.floor((Math.random() * 10) + 1)}`;
    //   vm.$router.push({
    //     path: url,
    //   });
    //   return false;
    // }
  }
  let arr = ["subjectSelectMajor", "addMajor", "mySubjectScheme"];
  if (arr.indexOf(url) > -1) {
    if (vm.cookie.get("token")) {
      let userInfo = vm.cookie.get("userInfo")
        ? JSON.parse(vm.cookie.get("userInfo"))
        : {};
      if (!userInfo.isVIP) {
        vm.$vipModal();
        return;
      }
    }
  }
  if (type == 1) {
    router.push({
      name: url,
      query: parameters,
    });
  } else {
    router.push({
      name: url,
      params: parameters,
    });
  }
  vm.$utils.removeDataCacheLocal("volunteer_list");
};

// 跳回nuxt
export const goBackNuxt = (option, data, type) => {
  let url = "";
  if (!data) {
    url = option;
  } else {
    let bUrl = "";
    for (var key in data) {
      bUrl += `${key}=${data[key]}&`;
    }
    url = `${option}?${bUrl}`;
  }
	if (window.sessionStorage.getItem('changeSteps') == 4) {
		vm.$confirm('现在离开可能无法保存当前志愿表信息，建议您先保存志愿表再离开。确定离开当前页面吗？', '提示', {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			type: "warning",
		}).then(() => {
			window.location.href = url;
			window.sessionStorage.setItem('changeSteps', 1);
		}).catch(() => {});
	} else {
		window.location.href = url;
		window.sessionStorage.setItem('changeSteps', 1);
	}
};

//live800
export const toLive800 = () => {
  let dataIndex = document.querySelectorAll(".live800url");
  let path = dataIndex[0].href;
  window.open(path, "_blank");
};

//页内跳转2
export const goUrls = (url, id, parameters) => {
  router.push({
    path: url + id,
    query: parameters,
  });
  vm.$utils.removeDataCacheLocal("volunteer_list");
};
export const toVueNoData = () => {
  let userInfo = vm.cookie.get("userInfo")
    ? JSON.parse(vm.cookie.get("userInfo"))
    : {};
  let userProvince = userInfo.province;
  let provinces = [
    // "黑龙江",
    // "甘肃",
    // "吉林",
    // "安徽",
    // "江西",
    // "贵州",
    // "广西",
    "河南",
    "陕西",
    "山西",
    "四川",
    "云南",
    "宁夏",
    "青海",
    "内蒙古",
  ];

  if (provinces.includes(userProvince)) {
    return true;
  } else {
    return false;
  }
};
export const toVueNoData2 = () => {
  let userInfo = vm.cookie.get("userInfo")
    ? JSON.parse(vm.cookie.get("userInfo"))
    : {};
  let userProvince = userInfo.province;
  let provinces = [
    "黑龙江",
    "甘肃",
    "吉林",
    "安徽",
    "江西",
    "贵州",
    "广西",
  ];
	console.log(provinces.includes(userProvince),"provinces.includes(userProvince)")
  if (provinces.includes(userProvince)) {
    return true;
  } else {
    return false;
  }
};
